/**
 * Converts a string to a kebab-case slug format
 * Strips all special characters and replaces spaces with hyphens
 *
 * @param {string} name - The name to convert to a slug
 * @returns {string} The slug in word-word2-word3 format
 */
export function generateSlug(name) {
    if (!name) return '';
    return name
        .toLowerCase()
        .replace(/[^a-z0-9\s-]/g, '') // Strip all special characters except spaces and hyphens
        .trim()
        .replace(/\s+/g, '-') // Replace spaces with hyphens
        .replace(/-+/g, '-') // Replace multiple consecutive hyphens with single hyphen
        .replace(/^-+|-+$/g, ''); // Remove leading and trailing hyphens
}
